import React from 'react'
import { useParams } from 'react-router-dom'
import ProjectForm from './ProjectForm'

const ProjectView = () => {
  const { id } = useParams()

  return (
    <ProjectForm 
      mode="view" 
      projectId={id}
    />
  )
}

export default ProjectView

